import { render, staticRenderFns } from "./MetaSendCapiEvent.vue?vue&type=template&id=a3a1c972"
import script from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
export * from "./MetaSendCapiEvent.vue?vue&type=script&lang=js"
import style0 from "./MetaSendCapiEvent.vue?vue&type=style&index=0&id=a3a1c972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports